import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import './assets/css/style.css';
import VueStripeCheckout from 'vue-stripe-checkout';


Vue.use(VueStripeCheckout, {
  publishableKey: 'pk_live_LEAR7HBwMHbL6Xq01gmEMvI800LkTLYFbM'
});


Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
